module.exports = __webpack_public_path__ + "static/media/logo_black.ae26e007.png";